import {
  Clock, AlertTriangle, Wrench, Package, CheckCircle,
  AlertCircle, Gauge, Settings2, Zap, Car, Bug
} from "lucide-react";

const statusConfig = {
  "check-in": { color: "bg-blue-100 text-blue-800", icon: Clock, label: "Check-in" },
  "diagnosis": { color: "bg-yellow-100 text-yellow-800", icon: AlertTriangle, label: "Diagnosis" },
  "in-progress": { color: "bg-orange-100 text-orange-800", icon: Wrench, label: "In Progress" },
  "parts-needed": { color: "bg-purple-100 text-purple-800", icon: Package, label: "Parts Needed" },
  "completed": { color: "bg-green-100 text-green-800", icon: CheckCircle, label: "Completed" },
  "ready-for-pickup": { color: "bg-emerald-100 text-emerald-800", icon: CheckCircle, label: "Ready for Pickup" }
};

const issuePriorityConfig = {
  "low": { color: "bg-gray-100 text-gray-800", label: "Low" },
  "medium": { color: "bg-blue-100 text-blue-800", label: "Medium" },
  "high": { color: "bg-orange-100 text-orange-800", label: "High" },
  "urgent": { color: "bg-red-100 text-red-800", label: "Urgent" },
  "critical": { color: "bg-red-100 text-red-800", label: "Critical" }
};

const issueStatusConfig = {
  "open": { color: "bg-red-100 text-red-800", icon: AlertCircle, label: "Open" },
  "in-progress": { color: "bg-yellow-100 text-yellow-800", icon: Wrench, label: "In Progress" },
  "resolved": { color: "bg-green-100 text-green-800", icon: CheckCircle, label: "Resolved" },
  "deferred": { color: "bg-gray-100 text-gray-800", icon: Clock, label: "Deferred" }
};

const issueCategoryConfig = {
  "engine": { icon: Gauge, label: "Engine" },
  "transmission": { icon: Settings2, label: "Transmission" },
  "electrical": { icon: Zap, label: "Electrical" },
  "brakes": { icon: AlertCircle, label: "Brakes" },
  "suspension": { icon: Car, label: "Suspension" },
  "general": { icon: Bug, label: "General" }
};

export { statusConfig, issuePriorityConfig, issueStatusConfig, issueCategoryConfig };
